
/* MANUFACTURER */
export const GET_MANUFACTURER_LISTING = "GET_MANUFACTURER_LISTING";
export const GET_MANUFACTURER_LISTING_SUCCESS = "GET_MANUFACTURER_LISTING_SUCCESS";
export const GET_MANUFACTURER_LISTING_FAIL = "GET_MANUFACTURER_LISTING_FAIL";

export const GET_MANUFACTURER_DETAILS = "GET_MANUFACTURER_DETAILS";
export const GET_MANUFACTURER_DETAILS_SUCCESS = "GET_MANUFACTURER_DETAILS_SUCCESS";
export const GET_MANUFACTURER_DETAILS_FAIL = "GET_MANUFACTURER_DETAILS_FAIL";

export const ADD_MANUFACTURER = "ADD_MANUFACTURER";
export const ADD_MANUFACTURER_SUCCESS = "ADD_MANUFACTURER_SUCCESS";
export const ADD_MANUFACTURER_FAIL = "ADD_MANUFACTURER_FAIL";

export const UPDATE_MANUFACTURER = "UPDATE_MANUFACTURER";
export const UPDATE_MANUFACTURER_SUCCESS = "UPDATE_MANUFACTURER_SUCCESS";
export const UPDATE_MANUFACTURER_FAIL = "UPDATE_MANUFACTURER_FAIL";

export const DELETE_MANUFACTURER = "DELETE_MANUFACTURER";
export const DELETE_MANUFACTURER_SUCCESS = "DELETE_MANUFACTURER_SUCCESS";
export const DELETE_MANUFACTURER_FAIL = "DELETE_MANUFACTURER_FAIL";

export const EXPORT_MANUFACTURER = "EXPORT_MANUFACTURER";
export const EXPORT_MANUFACTURER_SUCCESS = "EXPORT_MANUFACTURER_SUCCESS";
export const EXPORT_MANUFACTURER_FAIL = "EXPORT_MANUFACTURER_FAIL";

export const RESET_MANUFACTURER_STATE = 'RESET_MANUFACTURER_STATE';
export const RESET_MANUFACTURER_ATTACHMENT_STATE = 'RESET_MANUFACTURER_ATTACHMENT_STATE';